import React, { ReactElement } from 'react';
import { SideTabsLink } from './components/SideTabsLink';
import { NestedLinks } from './components/NestedLinks';

export interface SideTabsProps {
  tabs: SideTabs;
}

export function SideTabs({ tabs }: SideTabsProps): ReactElement {
  return (
    <nav aria-label="side-nav">
      <ul className="tabs tabs--vertical hidden-xs hidden-sm">
        {tabs.map((tab) =>
          'pathname' in tab ? (
            <SideTabsLink
              key={tab.label}
              pathname={tab.pathname}
              label={tab.label}
            />
          ) : (
            <NestedLinks
              key={tab.label}
              tabs={tab.sideTabs}
              label={tab.label}
            />
          ),
        )}
      </ul>
    </nav>
  );
}
